import {
  isAPP, isIOS, appVersion, isRebateApp, isBoxAPP,
} from '@/service/ua';
import { baseBackToHome } from '@/service/native';
import version from '@/service/utils/version';
import config from '@/service/config';

const link = {
  /**
     * url 链接
     * this 当前的vue实例
     * 针对特殊字符进行链接跳转商城首页指定tab（为兼容app跳转做特殊处理）
     */
  handleShopLink(url, vm) {
    if (url.indexOf('appTab=shop&&shopTab=') > -1) {
      const fid = url.split('shopTab=')[1].split('?')[0];
      if (isAPP) {
        const cacheKey = 'targetFenceId';
        window.localStorage.setItem(cacheKey, fid);
        baseBackToHome('shop');
      } else {
        vm.$router.push({
          path: '/shop',
          query: {
            fId: fid,
          },
        });
      }
      return true;
    }
    return false;
  },

  checkLimit(url) {
    // app才判断
    if (!isAPP) return false;
    function getQueryString(name) {
      const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
      const linkSplit = url.split('?');
      linkSplit.shift();
      const r = linkSplit.join().match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    }
    function formatLimit(limit) {
      let limitParams = {};
      if (limit.indexOf(',') > -1) {
        limit.split(',').forEach(item => {
          limitParams[item.split('-')[0]] = item.split('-')[1];
        });
        return limitParams;
      } if (limit.indexOf('-') === -1) {
        limitParams = {
          ios: limit,
          android: limit,
        };
        return limitParams;
      }
      return limitParams;
    }
    const limit = getQueryString('applimit');
    if (!limit) return false;
    const limitParams = formatLimit(limit);
    console.log();

    // app大雨
    return !version.versionCompare(appVersion, limitParams[isIOS ? 'ios' : 'android']);
  },

  // 跳转商城那边的订单详情
  orderLink(orderId, subEnv = '') {
    const origin = window.location.origin;
    // 非正式环境跨域跳转订单详情
    if (config.env !== 'prod') {
      // 非正式环境允许模拟
      const replaceEnv = window.location.origin.split('-')[0].split('//')[1];
      const newOrigin = subEnv ? origin.replace(replaceEnv, subEnv) : origin;
      const orderDetailUrl = `${newOrigin}/new/order/finish/finish.html?goodsOrderId=${orderId}`; // 需要添加参数
      return orderDetailUrl;
    }
    const orderDetailLink = `${origin}/new/order/finish/finish.html?goodsOrderId=${orderId}`; // 需要添加参数
    return orderDetailLink;
  },

  // 将对象转换成 url参数 ： a=xxx&b=xxx 这样的字符串
  paramToStr(params = {}) {
    const paramArray = [];
    const keys = Object.keys(params);

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (params[key] !== undefined) {
        paramArray.push(`${key}=${params[key]}`);
      }
    }
    return paramArray.join('&');
  },

  /** 跳转
 * @param path : string eg. /index
 * @param query: Object
 * @result void
*/

  nativeRouter(path, query = {}) {
    const urlQuery = {
      ...query,
      ZZCAppArg: query.ZZCAppArg ? `${query.ZZCAppArg},AppOpenPage` : 'AppOpenPage',
    };
    const queryString = '?';
    const arr = [];
    Object.keys(urlQuery).forEach(key => {
      arr.push(`${key}=${urlQuery[key]}`);
    });
    location.href = `${location.origin}${location.pathname}${queryString}${arr.join('&')}#${path}`;
  },
  nativeRouter2(path, query = {}) {
    const urlQuery = {
      ...query,
      ZZCAppArg: query.ZZCAppArg ? `${query.ZZCAppArg},AppOpenPage` : 'AppOpenPage',
    };
    const queryString = '?';
    const arr = [];
    Object.keys(urlQuery).forEach(key => {
      arr.push(`${key}=${urlQuery[key]}`);
    });
    location.href = `${location.origin}${location.pathname}#${path}${queryString}${arr.join('&')}`;
  },

  nativeRouter3(path, query = {}, vm) {
    const isZfbMiniWebview = localStorage.getItem('isZfbMiniWebview') === '1' ? 1 : 0;
    const pathName = query.pathName;
    let urlQuery = null;
    const replace = query.replace;
    delete query.pathName;
    delete query.replace;
    urlQuery = {
      ...query,
      ZZCAppArg: query.ZZCAppArg ? `${query.ZZCAppArg},${+new Date()}` : `${+new Date()}`,
    };

    const queryString = '?';
    const arr = [];
    const appArgArr = [];
    urlQuery.t = +new Date(); // 用于刷页面缓存

    if (urlQuery.ZZCAppArg.indexOf('appopenpage') !== -1 || urlQuery.ZZCAppArg.indexOf('AppOpenPage') !== -1) {
      appArgArr.push((isRebateApp || isBoxAPP) ? 'newPage=1' : 'appopenpage');
    }

    if (urlQuery.ZZCAppArg.indexOf('wholePageSelfOpen') !== -1) {
      appArgArr.push((isRebateApp || isBoxAPP) ? 'currentPage=1' : 'wholePageSelfOpen');
    }

    if (urlQuery.ZZCAppArg.indexOf('topbar_remove') !== -1) {
      appArgArr.push((isRebateApp || isBoxAPP) ? 'isImmersive=1' : 'topbar_remove');
    }

    if (!(isRebateApp || isBoxAPP)) {
      appArgArr.push('appopenpage');
    }

    appArgArr.push(+new Date());
    // const appArg = `?ZZCAppArg=${urlQuery.ZZCAppArg}`;
    const appArg = (isRebateApp || isBoxAPP) ? `?__webview_options__=${encodeURIComponent(appArgArr.join('&'))}` : `?ZZCAppArg=${appArgArr.join(',')}`;
    delete urlQuery.ZZCAppArg;
    Object.keys(urlQuery).forEach(key => {
      arr.push(`${key}=${urlQuery[key]}`);
    });
    // alert(`${location.origin}${pathName || location.pathname}${appArg}#${path}${queryString}${arr.join('&')}`);
    // if (isZfbMiniWebview) {
    //   location.href = `${location.origin}${pathName || location.pathname}#${path}${queryString}${arr.join('&')}`;
    // } else
    if (isAPP || !vm || isBoxAPP) {
      if (replace) {
        window.location.replace(`${location.origin}${pathName || location.pathname}${appArg}#${path}${queryString}${arr.join('&')}`);
      } else {
        location.href = `${location.origin}${pathName || location.pathname}${appArg}#${path}${queryString}${arr.join('&')}`;
      }
    } else if (replace) {
      vm.$router.replace({
        path,
        query: urlQuery,
      });
    } else {
      vm.$router.push({
        path,
        query: urlQuery,
      });
    }
  },

  openNewWebview(path) {
    if (path.indexOf('AppOpenPage') > -1) return path;
    if (path.indexOf('wholePageSelfOpen') > -1) return path.replace('wholePageSelfOpen', 'AppOpenPage');
    if (path.indexOf('ZZCAppArg') > -1) return path.split('ZZCAppArg=').join('ZZCAppArg=AppOpenPage,');
    path = path.indexOf('?') > -1
      ? `${path}&ZZCAppArg=AppOpenPage`
      : `${path}?ZZCAppArg=AppOpenPage`;
    return path;
  },
  getUrlParamsByName(name) {
    const reg = new RegExp(`${name}=([^&#]*)(&|$)`);
    const str = location.hash || location.search;
    const res = str.match(reg);
    const target = RegExp.$1;
    if (target && res) {
      return target;
    }
    return null;
  },
};

export default link;
